<template>
  <i-modal :title="LANG.differences">
    <ModalDifferencesContent :nodeId="document.nodeId"/>

    <template #footer>
      <i-button
        variant="secondary"
        @click.prevent="$emit('update:show', false)"
      >
        {{ LANG.cancel }}
      </i-button>
    </template>
  </i-modal>
</template>

<script>
import { mapState } from 'vuex';
import ModalDifferencesContent from './ModalDifferencesContent.vue';

export default {
  components: {
    ModalDifferencesContent,
  },
  props: {
    document: {
      default: () => ({}),
      type: Object,
    },
  },
  computed: {
    ...mapState(['LANG']),
  },
};
</script>
